import { render, staticRenderFns } from "./EditCustomProductModal.vue?vue&type=template&id=e889c57a&"
import script from "./EditCustomProductModal.vue?vue&type=script&lang=js&"
export * from "./EditCustomProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports